<template>
  <div class="rj-page-card">
    <p style="font-size:16px;font-weight:800; margin-bottom: 10px;">
      发票扫描件
    </p>

    <el-table v-loading="tableLoading" :data="tableData" border>
      <el-table-column prop="rfileName" label="文件名称" align="left" fixed="left">
        <template v-slot="{row}">
          <el-button type="text" style="margin-left: 10px" @click="openContract(row.rFileCode)">
            {{ row.rFileName }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="rUpdatedBy" label="上传人" align="left" />
      <el-table-column prop="rCreatedTime" label="上传时间" align="left" />
      <el-table-column prop="rUpdatedTime" label="最后更新时间" align="left" />
      <el-table-column prop="pname" label="操作" align="left" fixed="right">
        <template v-slot="{row}">
          <el-button type="text" style="margin-left: 10px" @click="downOneFile(row.rFileCode)">
            下载
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { attachmentGetToken, getUrlByFileID, getReturnsContractAttachment } from '@/API';

export default {
  data () {
    return {
      uplaodToken: {},
      tableLoading: false,
      tableData: [],
      fileserveDownUrl: ''
    };
  },

  created () {
    this.getUploadToken();
    this.searchFiles();
  },

  methods: {
    getUploadToken () {
      attachmentGetToken().then((res) => {
        let { status, data } = res.data;
        if (status === '200') {
          this.uplaodToken = data;
        }
      });
    },

    // 查询
    searchFiles () {
      this.tableLoading = true;
      getReturnsContractAttachment(this.$route.query.rcontractId, 3)
        .then((res) => {
          const { status, data } = res.data;
          this.tableLoading = false;
          if (status === '200') {
            this.tableData = data;
          }
        }).catch(() => {
          this.tableLoading = false;
        });
    },

    // 预览
    openContract (fileCode) {
      getUrlByFileID(fileCode)
        .then((res) => {
          const { status, data } = res.data;
          if (status === '200') {
            window.open(data);
          }
        });
    },

    // 下载
    downOneFile (id) {
      this.fileserveDownUrl = this.uplaodToken.downloadUrl + `/${id}?Token=${this.uplaodToken.token}`;
      this.$nextTick(() => {
        this.$refs.downTag.click();
      });
    }
  }

};
</script>
